import React, { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { activateMenu } from "redux/actions";
import { useAppDispatch } from "redux/store";
type Props = {
    id:number;
    upamandal_name: string;
    basti_name: string;
    gramams_formed: number;
    members_registered :number;
    total_basti :number;
    nagar_type:number;
    total_gramas :number;
    basti_gramam_type:string;
};
export const UpmandalBasthiReportCard: React.FC<Props> = ({id, nagar_type,basti_name,upamandal_name,gramams_formed,basti_gramam_type,members_registered,total_basti ,total_gramas }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const handleCardClick = (id,basti_gramam_type,upamandal_name) => {
        // dispatch(activateMenu(id))
      localStorage.setItem("basti_gramam_type", basti_gramam_type)
      localStorage.setItem("upamandal_name", upamandal_name)
      localStorage.setItem("basti_name", basti_name)
    if(total_gramas >0) {
        navigate('/gramamreports/'+id, { replace: true });
    }else if(total_basti>0){
        navigate('/samithi_members/'+id, { replace: true });
    }
    }

    // console.log("29grmamsFormed",gramams_formed)
    // console.log("30totalgrmams",total_gramas)

    return (
        <Col md={4} xl={3} xs={6} className="cursor-pointer mb-4" onClick={() => { handleCardClick(id,basti_gramam_type,upamandal_name); }}>
                                 <Card className="shadow h-110" style={{ borderLeft: (gramams_formed > 0 || members_registered > 0) ? '5px solid #194380' : '5px solid #FF0000' }}>
                <Card.Body style={{padding :"3.2rem"}}> 
                    <div className="row no-gutters align-items-center">
                        <div className="col mr-2">
                        
                            <div className="text-xl font-weight-bold text-uppercase mb-1" style={{ color: (gramams_formed > 0 || members_registered > 0) ? '#194380' : '#FF0000' }}>
                              {basti_gramam_type==="gramam" ||   basti_gramam_type==="basti" ? <p>{basti_name}</p> :<p>{upamandal_name}</p>}</div>
                            <div className=" mb-0 font-weight-bold text-gray-800"></div>
                             
                        </div>
                        <div className=" mb-0 font-weight-bold text-gray-800">
                            {/* <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                                                        style={{color: "#FF0000"}}
 */}
                            {total_basti >0 &&
                            <p>{members_registered}  Addresses Registered</p>
}
                        </div>
                        <div className=" mb-0.4 font-weight-bold text-gray-800">
                            {total_gramas >0 &&
                 <p>{gramams_formed} Over  /  {total_gramas} Total Villages</p>
}
                        </div>

                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

